import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: 'How much would you like to stake?',
  description:
    'Staking {symbol} in the {module} helps to secure the protocol in exchange for {incentives}.',
  safetyModule: 'Safety Module',
  protocolIncentives: 'protocol incentives',
  availableToStake: 'Available to stake',
});
